import CcfAppToastMessageStyles from './ccf-app-toast-message-style';
import { Box, useTheme } from '@mui/material';
import { CcfTypography } from '../ccf-typography/ccf-typography';
import CcfButton from '../ccf-button/ccf-button';
import { CcfTranslationKey } from '../../ccf-translator/ccf-translator';


export interface CcfAppToastMessageProps {
  type:string; // info, error, success, warning
  titleKey?:CcfTranslationKey;
  messageKey?:CcfTranslationKey;
  descriptionKey?:CcfTranslationKey;
  primaryBtnText?:CcfTranslationKey;
  secondaryBtnText?:CcfTranslationKey ;
  descriptionMessage?: string;
  titleMessage?:string;
  onClickHandler?: (event: React.MouseEvent<HTMLElement>) => void;
  triggerPrimaryHandler?: () => void;
  triggerSecondaryHandler?: () => void
  extraArgs?: { format: (number | string)[] };
  children?: React.ReactNode;
}
/***
 * @example Use three type of containers to load this component 
 * ie. AppToastContainer - container to load toast message at application level
 *     ComponentToastContainer - container to load toast message at component level
 *     ToolTipToastContainer - container to show toast message as tooltip
 */
export function CcfAppToastMessage(props: CcfAppToastMessageProps) {
  const {titleKey, type, messageKey , descriptionKey,descriptionMessage, primaryBtnText , secondaryBtnText,titleMessage,extraArgs, children} = props;
  const theme = useTheme();
  const classes= CcfAppToastMessageStyles(theme);
 
  /**
   * @example primary button click handler
   */
  const primaryBtnClickHandler = ()=>{
    props.triggerPrimaryHandler &&  props.triggerPrimaryHandler();
  }
  /**
   * @example secondary button click handler
   */
  const secondaryBtnClickHandler =()=>{
    props.triggerSecondaryHandler &&  props.triggerSecondaryHandler();
  }
  return (
    <Box sx={classes.toastMessage} className={type}>
      {titleKey && <div className= 'titleText'> <CcfTypography translationKey={titleKey} variant='h4'/></div>}
      <div className= 'text'><CcfTypography sx={type==='agentMessage'? classes.text : {}} translationKey={messageKey} variant='h5' extraArgs={extraArgs}>{titleMessage} </CcfTypography></div>
      <div className= 'subMessageText'>
        {descriptionMessage ? <CcfTypography sx={type==='agentMessage'? classes.subText : {}} dangerouslySetInnerHTML={{ __html: descriptionMessage as string }} variant='h6' ></CcfTypography>
          : <CcfTypography translationKey={descriptionKey} variant='h6' />}
      </div>
      {children}
      <Box className= 'confimationBtn' sx={type === 'warning logoutConfirmationPanel' ? classes.logoutConfirmationPanel : {}}>
        {primaryBtnText && <CcfButton
          sx={type==='warning networkFailureError' ? classes.primaryBtn:{}}
          onClick={() => primaryBtnClickHandler()}
          variant="contained"
          size="small"
          primary
          autoFocus
          data-testid = 'primary-button-click'
        >
          <CcfTypography variant='h5' translationKey={primaryBtnText} />
        </CcfButton>}
        {secondaryBtnText && <CcfButton
          sx={type==='agentMessage'? classes.secondaryButton :{}}
          onClick={() => secondaryBtnClickHandler()}
          variant="contained"
          size="small"
          data-testid = 'secondary-button-click'
        >
          <CcfTypography variant='h5' translationKey={secondaryBtnText} />
        </CcfButton>}
      </Box>
    </Box>
  );
}

export default CcfAppToastMessage;
